// Error codes of the Startbox plane API (technical design §4.2).
export enum Errors {
    InternalServerError      = 1,
    InvalidData              = 2,
    NotFound                 = 3,
    Unauthorized             = 4,
    FailedToInsert           = 5,
    Forbidden                = 6,
    Conflict                 = 7,
    NoCapacity               = 8,
    UpstreamFailure          = 9,
    IncusUnavailable         = 10,
    Gone                     = 11,
    NoHostnameAvailable      = 12,
    InstanceTypeLimitReached = 13,
    ImagePreparing           = 14,
    KVMUnavailable           = 15,
}
